// extracted by mini-css-extract-plugin
export var configurationSection = "_tn-0";